import React, { useState } from "react";
import styled from "styled-components";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import { Box, IconButton } from "@material-ui/core";

const StyledContainer = styled.div`
  position: relative;
`;

const StyledPanel = styled.div`
  background-color: rgb(250, 251, 252);
  border-right: 1px solid rgba(0, 0, 0, 0.12);
  transition: max-width 0.25s ease-in-out;
  max-width: 24rem;
  height: 100%;
  overflow: hidden;
`;

const StyledInnerPanel = styled.div`
  width: 24rem;
  height: 100%;
  position: relative;
`;

const StyledButtonWrapper = styled(Box)`
  position: absolute;
  right: -0.625rem;
  top: 1.5rem;
  z-index: 1;
  transition: opacity 0.125s ease-in-out;
`;

const StyledReduceButton = styled(IconButton)`
  background-color: #fff;
  border-radius: 50%;
  border: 1px solid #c0c0c0;
  width: 1.5rem;
  height: 1.5rem;
  box-shadow: 0 1px 0 1px rgba(0, 0, 0, 0.07);
  transition: all 0.125s ease-in-out;

  .MuiSvgIcon-root {
    width: 1.25rem;
    height: 1.25rem;
  }

  &:hover,
  &:focus {
    background-color: rgba(0, 72, 120, 1);
    color: #fff;
  }
`;

const StyledExpandButton = styled(IconButton)`
  background-color: #fff;
  border-radius: 50%;
  border: 1px solid #c0c0c0;
  width: 1.5rem;
  height: 1.5rem;
  box-shadow: 0 1px 0 1px rgba(0, 0, 0, 0.07);
  font-size: 1rem;
  transition: all 0.125s ease-in-out;

  .MuiSvgIcon-root {
    width: 1.25rem;
    height: 1.25rem;
  }

  &:hover,
  &:focus {
    background-color: rgba(0, 72, 120, 1);
    color: #fff;
  }
`;

interface ILeftHiddablePanelProps {
  children?: React.ReactNode;
}

const LeftHiddablePanel = (props: ILeftHiddablePanelProps) => {
  const { children } = props;
  const [state, setState] = useState({
    expanded: true,
    hover: false,
  });

  const handleMouseEnter = () => {
    setState((s) => ({ ...s, hover: true }));
  };

  const handleMouseLeave = () => {
    setState((s) => ({ ...s, hover: false }));
  };

  const handleReduceClick = () => {
    setState((s) => ({ ...s, expanded: false }));
    setTimeout(() => {
      window.dispatchEvent(new Event("resize"));
    }, 500);
  };

  const handleExpandClick = () => {
    setState((s) => ({ ...s, expanded: true }));
    setTimeout(() => {
      window.dispatchEvent(new Event("resize"));
    }, 500);
  };

  return (
    <StyledContainer
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <StyledPanel
        className="CMuiLeftPanel CMuiLeftHiddablePanel"
        style={{
          maxWidth: state.expanded ? "24rem" : "1.25rem",
        }}
      >
        <StyledInnerPanel className="CMuiLeftPannel-inner">
          {children}
        </StyledInnerPanel>
      </StyledPanel>
      <StyledButtonWrapper
        style={{
          opacity: !state.expanded || state.hover ? 1 : 0,
        }}
      >
        {state.expanded ? (
          <StyledReduceButton onClick={handleReduceClick}>
            <ChevronLeftIcon />
          </StyledReduceButton>
        ) : (
          <StyledExpandButton onClick={handleExpandClick}>
            <ChevronRightIcon />
          </StyledExpandButton>
        )}
      </StyledButtonWrapper>
    </StyledContainer>
  );
};

export default LeftHiddablePanel;
